import React from 'react';
import { FileTextIcon, UsersIcon, StarIcon, HeartIcon } from 'lucide-react';
export const SocialProof: React.FC = () => {
  return <section className="bg-white border-b border-gray-200" data-id="element-239">
      <div className="bg-green-50 py-3 px-4 text-center border-b border-green-100" data-id="element-240">
        <div className="flex items-center justify-center gap-3 flex-wrap" data-id="element-241">
          <div className="flex -space-x-2" data-id="element-242">
            {[1, 2, 3, 4, 5].map(i => <img key={i} src={`https://i.pravatar.cc/100?img=${i * 10}`} alt="User avatar" className="w-8 h-8 rounded-full border-2 border-white" data-id="element-243" />)}
          </div>
          <p className="text-green-800 font-medium text-sm md:text-base" data-id="element-244">
            Ya elegido por <span className="font-bold" data-id="element-245">2.847+</span>{' '}
            entrenadores en toda Latinoamérica
          </p>
        </div>
      </div>

      <div className="max-w-6xl mx-auto py-6 px-4" data-id="element-246">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-247">
          <div className="flex items-center gap-4 p-4 rounded-xl bg-blue-50/50" data-id="element-248">
            <div className="bg-blue-100 p-3 rounded-lg" data-id="element-249">
              <FileTextIcon className="w-6 h-6 text-blue-600" data-id="element-250" />
            </div>
            <div data-id="element-251">
              <p className="font-bold text-xl text-gray-900" data-id="element-252">300+</p>
              <p className="text-sm text-gray-600" data-id="element-253">Recursos digitales</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-xl bg-orange-50/50" data-id="element-254">
            <div className="bg-orange-100 p-3 rounded-lg" data-id="element-255">
              <UsersIcon className="w-6 h-6 text-orange-600" data-id="element-256" />
            </div>
            <div data-id="element-257">
              <p className="font-bold text-xl text-gray-900" data-id="element-258">2.8k+</p>
              <p className="text-sm text-gray-600" data-id="element-259">Entrenadores activos</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-xl bg-green-50/50" data-id="element-260">
            <div className="bg-green-100 p-3 rounded-lg" data-id="element-261">
              <StarIcon className="w-6 h-6 text-green-600 fill-current" data-id="element-262" />
            </div>
            <div data-id="element-263">
              <p className="font-bold text-xl text-gray-900" data-id="element-264">4.9/5</p>
              <p className="text-sm text-gray-600" data-id="element-265">Valoración media</p>
            </div>
          </div>

          <div className="flex items-center gap-4 p-4 rounded-xl bg-red-50/50" data-id="element-266">
            <div className="bg-red-100 p-3 rounded-lg" data-id="element-267">
              <HeartIcon className="w-6 h-6 text-red-600 fill-current" data-id="element-268" />
            </div>
            <div data-id="element-269">
              <p className="font-bold text-xl text-gray-900" data-id="element-270">100%</p>
              <p className="text-sm text-gray-600" data-id="element-271">Satisfacción</p>
            </div>
          </div>
        </div>
      </div>
    </section>;
};